import {
  IConstraintViolationMessage,
  IErrorMessage,
} from "./components/errorMessage";
import { DropDownResponse, OptionTypeBase } from "../types/common";
import { EquivalenceType } from "../constant";
import { DateRange } from "../types/components/datetime";

/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export interface CreateCodingSystemRequest {
  hl7Scheme?: string;
  hl7Version?: string;
  fhirSystem?: string;
  fhirVersion?: string;
}

export interface BodyPartRequest {
  id?: string;
  dicomCode?: string;
  snomedCtCode?: string;
  snomedCtCodeMeaning?: string;
  snomedCtPaired?: boolean;
}

export interface ICodeResponse {
  id?: string;
  code?: string;
  display?: string;
  enabled?: boolean;
  system?: CreateCodingSystemRequest;
}

export interface ICodeMappingType {
  codeId?: string;
  equivalence?: string;
  label?: string;
  code?: ICodeResponse;
}

export interface ICodeRvu {
  value?: string;
  effective?: DateRange;
}

export const initialDefaultCodeRvuState: ICodeRvu = {
  value: "",
  effective: undefined,
};

export const initialDefaultCodeMappingTypeState: ICodeMappingType = {
  codeId: "",
  equivalence: EquivalenceType.EXACT,
  label: "",
};

export interface ICodeRequest {
  id?: string;
  code?: string;
  display?: string;
  enabled?: boolean;
  system?: CreateCodingSystemRequest;
  rvu?: string;
  effectiveCodeRvu?: ICodeRvu;
  bodyPart?: BodyPartRequest;
  reportingQualifications?: OptionTypeBase[] | DropDownResponse<string>[];
  verifyingQualifications?: OptionTypeBase[] | DropDownResponse<string>[];
  codeTableId?: string;
  codeTable?: OptionTypeBase;
  codeTableMappingId?: string;
  billingCodes?: OptionTypeBase[];
  billingCodeIds?: string[];
  codeMappings?: ICodeMappingType[];
  codeRvus?: ICodeRvu[];
}

export interface IWorklistCodeRequest {
  id?: string;
  rvu?: number;
  bodyPartId?: string;
  reportingQualificationIds?: string[];
  verifyingQualificationIds?: string[];
  codeRvus?: ICodeRvu[];
}

export const defaultCodeManagementValue: ICodeRequest = {
  code: "",
  display: "",
  system: null,
  enabled: true,
  rvu: undefined,
  bodyPart: undefined,
  codeMappings: [initialDefaultCodeMappingTypeState],
};

export interface ICodeManagementForm {
  data?: ICodeRequest;
  errorMessage?: IErrorMessage | IConstraintViolationMessage | null;
  readonly?: boolean;
  trigger?: boolean;
  isDark?: boolean;
  worklistSpace?: boolean;
  bodyPartOptions?: OptionTypeBase[];
  qualificationOptions?: OptionTypeBase[];
  codeTableOptions?: OptionTypeBase[];
  lazyFetchCodes?: (
    query: string,
    callback: (options: OptionTypeBase[]) => void
  ) => void;
  dateFormat?: string;
}
